(function (Drupal, once) {
  Drupal.behaviors.shareModal = {
    attach: function (context) {
      once("share-modal", "[data-share-modal-open]", context).forEach(
        function (button) {
          button.addEventListener("click", function (e) {
            e.preventDefault();
            const modal = document.querySelector(
              ".profissional-de-saude__share-modal",
            );
            if (modal) {
              modal.classList.add("profissional-de-saude__share-modal--open");
              document.body.classList.add("hsl-modal-open");

              // Focus trap
              const firstFocusable = modal.querySelector(
                ".profissional-de-saude__share-button-item, .profissional-de-saude__share-modal-close",
              );
              if (firstFocusable) {
                firstFocusable.focus();
              }
            }
          });
        },
      );

      once("share-modal-close", "[data-share-modal-close]", context).forEach(
        function (closeButton) {
          closeButton.addEventListener("click", function (e) {
            e.preventDefault();
            const modal = document.querySelector(
              ".profissional-de-saude__share-modal",
            );
            if (modal) {
              modal.classList.remove(
                "profissional-de-saude__share-modal--open",
              );
              document.body.classList.remove("hsl-modal-open");
            }
          });
        },
      );

      // Copy URL functionality
      once(
        "share-copy",
        ".profissional-de-saude__share-button-copy",
        context,
      ).forEach(function (copyButton) {
        copyButton.addEventListener("click", function (e) {
          e.preventDefault();
          const url = this.getAttribute("data-share-url");
          const fullUrl = window.location.origin + url;

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(fullUrl).then(function () {
              copyButton.classList.add(
                "profissional-de-saude__share-button-item--copied",
              );
              const p = copyButton.querySelector("p");
              if (p) {
                const originalText = p.textContent;
                p.textContent = Drupal.t("URL copiada!");
                setTimeout(function () {
                  copyButton.classList.remove(
                    "profissional-de-saude__share-button-item--copied",
                  );
                  p.textContent = originalText;
                }, 2000);
              }
            });
          } else {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = fullUrl;
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.select();
            try {
              document.execCommand("copy");
              copyButton.classList.add(
                "profissional-de-saude__share-button-item--copied",
              );
              const p = copyButton.querySelector("p");
              if (p) {
                const originalText = p.textContent;
                p.textContent = Drupal.t("URL copiada!");
                setTimeout(function () {
                  copyButton.classList.remove(
                    "profissional-de-saude__share-button-item--copied",
                  );
                  p.textContent = originalText;
                }, 2000);
              }
            } catch (err) {
              console.error("Failed to copy URL:", err);
            }
            document.body.removeChild(textArea);
          }
        });
      });

      // Close on Escape key
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          const modal = document.querySelector(
            ".profissional-de-saude__share-modal.profissional-de-saude__share-modal--open",
          );
          if (modal) {
            modal.classList.remove("profissional-de-saude__share-modal--open");
            document.body.classList.remove("hsl-modal-open");
          }
        }
      });
    },
  };
})(Drupal, once);
